import _ from 'lodash'

export const CATS = {
    SAMEN: 'samen',
    CONF: 'conf',
    ERKEN: 'erken',
    ZORG: 'zorg',
    GELIJK: 'gelijk',
    ZELFSTURING: 'zelfsturing',
    MACHT: 'macht',
    VOORSPELBAAR: 'voorspelbaar',
    PRESTATIE: 'prestatie',
    ZELFONTPLOOI: 'zelfontplooi',
    DUURZAAM: 'duurzaam',
    INTEGRITEIT: 'integriteit',
    INNOVATIE: 'innovatie',
    DAADKRACHT: 'daadkracht',
} as const

export const DIMENSIONS = {
    SOCIAL_VALUE: 'Social Values',
    GROWTH_FLEXIBILITY: 'Growth & Flexibility',
    CONSERVATIVENESS: 'Conservativeness',
    QUALITY: 'Quality',
    RECOGNITION: 'Recognition',
    POWER: 'Power',
} as const;

export type DIMENSIONS_TYPE = (typeof DIMENSIONS)[keyof typeof DIMENSIONS]

// utility type
export type Concat<T extends string[]> = T extends [infer F, ...infer R]
    ? F extends string
        ? R extends string[]
            ? `${F}${Concat<R>}`
            : never
        : never
    : ''
type VALUES_TYPES = (typeof CATS)[keyof typeof CATS]

export const ALL_CATS = Object.values(CATS)
export type CATS_TYPE = (typeof CATS)[keyof typeof CATS]

export type VALUES =
    | Concat<[VALUES_TYPES, '1']>
    | Concat<[VALUES_TYPES, '2']>
    | Concat<[VALUES_TYPES, '3']>
    | Concat<[VALUES_TYPES, '4']> // FIXME

// TODO use everywhere instead of VALUES? 
export type VALUES_3 =
    | Concat<[VALUES_TYPES, '1']>
    | Concat<[VALUES_TYPES, '2']>
    | Concat<[VALUES_TYPES, '3']>;
    
// FIXME set
const testMap: Record<VALUES, number> = {
    samen1: 0,
    conf1: 0,
    erken1: 0,
    zorg1: 0,
    gelijk1: 0,
    zelfsturing1: 0,
    macht1: 0,
    voorspelbaar1: 0,
    prestatie1: 0,
    zelfontplooi1: 0,
    duurzaam1: 0,
    integriteit1: 0,
    innovatie1: 0,
    daadkracht1: 0,
    samen2: 0,
    conf2: 0,
    erken2: 0,
    zorg2: 0,
    gelijk2: 0,
    zelfsturing2: 0,
    macht2: 0,
    voorspelbaar2: 0,
    prestatie2: 0,
    zelfontplooi2: 0,
    duurzaam2: 0,
    integriteit2: 0,
    innovatie2: 0,
    daadkracht2: 0,
    samen3: 0,
    conf3: 0,
    erken3: 0,
    zorg3: 0,
    gelijk3: 0,
    zelfsturing3: 0,
    macht3: 0,
    voorspelbaar3: 0,
    prestatie3: 0,
    zelfontplooi3: 0,
    duurzaam3: 0,
    integriteit3: 0,
    innovatie3: 0,
    daadkracht3: 0,
    samen4: 0,
    conf4: 0,
    erken4: 0,
    zorg4: 0,
    gelijk4: 0,
    zelfsturing4: 0,
    macht4: 0,
    voorspelbaar4: 0,
    prestatie4: 0,
    zelfontplooi4: 0,
    duurzaam4: 0,
    integriteit4: 0,
    innovatie4: 0,
    daadkracht4: 0,
}

export function isVALUE(value: string): value is VALUES {
    // 'is' if this is true, the value's type is narrowed to VALUES
    // 'as' forces the type as a map object
    // 'in' in TS only checks the runtime type, even if runtime object is empty
    // return value in ({} as Record<VALUES, any>)
    // return value in ({} as {[K in VALUES]: any})
    return value in testMap
}

export const allCats: CATS_TYPE[] = Object.values(CATS)
export const DEFAULT_CAT_MAP: Record<CATS_TYPE, number> = allCats.reduce<
    Record<CATS_TYPE, number>
>(
    (acc, cat) => {
        acc[cat] = 0
        return acc
    },
    {} as Record<CATS_TYPE, number>
)
